<template>
    <div>
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
        <rkm-area type="fieldset" title="Dados da receita">
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            label="Data da receita"
                            :max-date="form.dataAtual"
                            v-model="receitaAtual.dataReceita"
                            :validations="validations.dataReceita"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :repository="repositories.usuario"
                            :requestQueryStringParams="{ with_not_regularized: true }"
                            :searchFields="fields.autocomplete.usuario"
                            :validations="validations.medicoSolicitante"
                            label="Médico solicitante"
                            text-field="cidadaoNome"
                            v-model="receitaAtual.medicoSolicitante"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            label="Data do registro"
                            :value="dataRegistroAtual"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="2" class="mt-1">
                        <rkm-form-radio-group
                            label="Tipo da receita"
                            v-model="receitaAtual.isReceitaSus"
                        >
                            <rkm-form-radio :value="true">SUS</rkm-form-radio>
                            <rkm-form-radio :value="false">Outras</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Adicionar item"
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-select
                            @change="handleTipoMedicamentoChange"
                            label="Tipo"
                            v-model="isNaoPadronizado"
                        >
                            <rkm-form-select-option :value="false">Padronizado</rkm-form-select-option>
                            <rkm-form-select-option :value="true">Não padronizado</rkm-form-select-option>
                        </rkm-form-select>
                    </rkm-col>
                    <rkm-col cols="4">
                            <rkm-form-input-autocomplete
                                v-if="!isNaoPadronizado"
                                :key="`material-${itemFieldKey}`"
                                :repository="repositories.material"
                                :search-fields="fields.autocomplete.material"
                                :validations="validations.material"
                                label="Item"
                                :text-field="function(item) {
                                    const programas = [item.altoCusto, item.programaRemedioEmCasa, item.acaoJudicial, item.remume];
                                    const programasSeparados = programas.filter(Boolean).join(', ');
                                    const programasFormatados = programasSeparados ? `(${programasSeparados})` : '';

                                    return `${item.descricaoCompleta || item.descricao} ${programasFormatados}`
                                }"
                                v-model="itemAtual.medicamento"
                            />
                            <rkm-form-input-autocomplete
                                v-else
                                :key="`nao-padronizado-${itemFieldKey}`"
                                :repository="repositories.medicamentoNaoPadronizado"
                                :search-fields="fields.autocomplete.medicamentoNaoPadronizado"
                                :validations="validations.material"
                                label="Item"
                                text-field="descricao"
                                v-model="itemAtual.medicamentoNaoPadronizado"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-button
                                        @click="$refs.ModalCadastro.open(form.medicamentosNaoPadronizadosCadastrados)"
                                        color="primary"
                                        title="Cadastrar medicamento não padronizado"
                                    >
                                        <rkm-icon icon="plus" />
                                    </rkm-button>
                                </rkm-input-group-append>
                            </rkm-form-input-autocomplete>
                    </rkm-col>
                    <rkm-col cols="3">
                        <rkm-form-input
                                :validations="validations.quantidade"
                                label="Quantidade"
                                type="number"
                                v-model="itemAtual.quantidade"
                            >
                        </rkm-form-input>
                    </rkm-col>
                    <rkm-col cols="3">
                        <rkm-form-select
                            @change="handleMotivoChange"
                            :options="form.motivoMedicamentoNaoAtendido"
                            :validations="validations.motivo"
                            default-option-text="Selecione"
                            label="Motivo"
                            show-default-option
                            text-field="nome"
                            v-model="motivoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            label=" Justificativa"
                            :validations="validations.justificativa"
                            maxlength="150"
                            v-model="itemAtual.justificativa"
                            :disabled="motivoId !== enums.motivo.OUTROS"
                        />
                    </rkm-col>
                </rkm-row>
                <rkm-row>
                    <rkm-col class="flex-grow-0 text-nowrap">
                        <rkm-button
                            :label="false"
                            @click="incluir()"
                            color="primary"
                        >
                            <template v-if="itemEmEdicaoId || receitaEmEdicaoId">
                                Salvar
                            </template>
                            <template v-else>
                                Incluir
                            </template>
                        </rkm-button>

                        <rkm-button
                            v-if="itemEmEdicaoId || receitaEmEdicaoId || receitaAtual.id"
                            :label="false"
                            @click="cancelarEdicao()"
                            color="danger"
                        >
                            Cancelar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
    </rkm-form>

        <rkm-area
            v-if="itensReceitaAtual.length > 0"
            type="fieldset"
            :title="`Medicamentos incluídos nesta receita (${itensReceitaAtual.length})`"
        >
            <rkm-table
                :items="itensReceitaAtual"
                :fields="fields.itensReceitaAtual"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click.stop="editarItem(item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click="removerItemAtual(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <ModalCadastro
            ref="ModalCadastro"
            @saveNaoPadronizados="saveNaoPadronizados"
        />

        <List
            :form="form"
            :model="model"
            @edit="editarReceita($event)"
            @editItem="editarItem($event)"
        />
    </div>
</template>


<script>
import { repository, object, error, data } from '@/mixins'

//Enums
import motivo from '@/enums/farmacia/motivoMedicamentoNaoAtendido'

//Moment
import moment from 'moment'

import List from './List'
import ModalCadastro from '../medicamento-nao-padronizado/cadastro/Modal'
export default {
    components:{ List, ModalCadastro },
    computed:{
        fields() {
            return {
                autocomplete: {
                    usuario: [{ key: "cadastro_cidadao.nome", searchable: true }],
                    material: [
                        { key: "codigo_material", searchable: true },
                        { key: "descricao", searchable: true },
                    ],
                    medicamentoNaoPadronizado: [{ key: "descricao", searchable: true }],
                },
                itensReceitaAtual: [
                    { label: 'Medicamento', key: 'medicamento.descricao', sortable: true, },
                    { label: 'Quantidade', key: 'quantidade', sortable: true, },
                    { label: 'Motivo', key: 'motivo', sortable: true, },
                    { label: 'Justificativa', key: 'justificativa', sortable: true, },
                    { label: 'Ações', key: 'actions', class: 'col-min' },
                ],
            }
        },
        receitaAtualNaLista() {

            if (this.receitaEmEdicaoId) {

                return this.model.medicamentoNaoAtendido.find(r => !r.deleted && r.id === this.receitaEmEdicaoId) || null
            }

            if (!this.receitaAtual.id) {

                return null
            }

            return this.model.medicamentoNaoAtendido.find(r => !r.deleted && r.id === this.receitaAtual.id) || null
        },
        itensReceitaAtual() {

            return this.receitaAtualNaLista
                ? this.receitaAtualNaLista.items.filter(i => !i.deleted)
                : []
        },
        dataRegistroAtual() {

            return this.receitaAtualNaLista
                ? this.receitaAtualNaLista.dataRegistro
                : this.form.dataAtual
        },
        validations() {
            return {
                material: { required: true },
                dataReceita: { required: true },
                quantidade: { required: true, numeric: true, min_value: 1 },
                medicoSolicitante: {required: true},
                motivo: {required: true},
                justificativa: { required: this.motivoId === this.enums.motivo.OUTROS, min:3, max: 150 }

            }
        },
    },
    data:() => ({
        receitaAtual: {
            id: null,
            dataReceita: null,
            medicoSolicitante: null,
            isReceitaSus: true,
        },
        receitaEmEdicaoId: null,
        itemEmEdicaoId: null,
        itemAtual: {
            medicamento: null,
            medicamentoNaoPadronizado: null,
            quantidade: null,
            justificativa: null,
        },
        motivoId: null,
        isNaoPadronizado: false,
        itemFieldKey: 0,
        enums:{
            motivo
        }
    }),
    created() {

        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            medicamentoNaoPadronizado: this.getConectaSusRepository('cadastro.medicamentoNaoPadronizado'),
            dispensacao: this.getConectaSusRepository('farmacia.dispensacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    methods:{
        resetItem() {

            this.itemEmEdicaoId = null
            this.isNaoPadronizado = false
            this.itemAtual = {
                medicamento: null,
                medicamentoNaoPadronizado: null,
                quantidade: null,
                justificativa: null,
            }
            this.motivoId = null
            this.itemFieldKey++

            if (this.$refs.RkmForm) this.$refs.RkmForm.resetValidator()
        },
        cancelarEdicao() {

            this.receitaEmEdicaoId = null
            this.receitaAtual = {
                id: null,
                dataReceita: null,
                medicoSolicitante: null,
                isReceitaSus: true,
            }

            this.resetItem()
        },
        handleTipoMedicamentoChange(){

            this.itemAtual.medicamento = null
            this.itemAtual.medicamentoNaoPadronizado = null
        },
        handleMotivoChange(){

            if (this.motivoId !== this.enums.motivo.OUTROS) {

                this.itemAtual.justificativa = null
            }
        },
        saveNaoPadronizados(items) {

            this.form.medicamentosNaoPadronizadosCadastrados = items
        },
        resolverReceitaAtual() {

            if (this.receitaEmEdicaoId) {

                const receitaEmEdicao = this.model.medicamentoNaoAtendido.find(r => !r.deleted && r.id === this.receitaEmEdicaoId)

                if (receitaEmEdicao) return receitaEmEdicao
            }

            if (this.receitaAtual.id) {

                const receitaExistente = this.model.medicamentoNaoAtendido.find(r => !r.deleted && r.id === this.receitaAtual.id)

                if (receitaExistente) return receitaExistente
            }

            const medicoSolicitante = this.receitaAtual.medicoSolicitante
            const dataReceitaFormatada = this.getFormatedDate(this.receitaAtual.dataReceita, 'DD/MM/YYYY')

            const receita = {
                id: `${new Date().getTime()}-receita-medicamento-nao-atendido`,
                dataReceita: dataReceitaFormatada,
                dataRegistro: this.getFormatedDate(new Date(), 'DD/MM/YYYY'),
                medicoSolicitante: {
                    id: medicoSolicitante.id,
                    nome: medicoSolicitante.cidadaoNome
                },
                isReceitaSus: this.receitaAtual.isReceitaSus,
                items: [],
                save: true,
                deleted: false,
            }

            this.model.medicamentoNaoAtendido.push(receita)

            this.receitaAtual.id = receita.id

            return receita
        },
        editarReceita(receita) {

            this.resetItem()

            this.receitaEmEdicaoId = receita.id

            this.receitaAtual.id = receita.id
            this.receitaAtual.dataReceita = moment(receita.dataReceita, 'DD/MM/YYYY').toDate()
            this.receitaAtual.medicoSolicitante = {
                ...receita.medicoSolicitante,
                cidadaoNome: receita.medicoSolicitante.nome
            }
            this.receitaAtual.isReceitaSus = receita.isReceitaSus

            this.$nextTick(() => {

                this.$refs.RkmForm.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
            })
        },
        sincronizarCabecalhoReceitaEmEdicao() {

            const receitaId = this.receitaEmEdicaoId || this.receitaAtual.id

            if (!receitaId) return

            const receita = this.model.medicamentoNaoAtendido.find(r => !r.deleted && r.id === receitaId)

            if (!receita) return

            const medicoSolicitante = this.receitaAtual.medicoSolicitante

            if (!this.receitaAtual.dataReceita || !medicoSolicitante || !medicoSolicitante.id) return

            receita.dataReceita = this.getFormatedDate(this.receitaAtual.dataReceita, 'DD/MM/YYYY')
            receita.medicoSolicitante = {
                id: medicoSolicitante.id,
                nome: medicoSolicitante.cidadaoNome
            }
            receita.isReceitaSus = this.receitaAtual.isReceitaSus
            receita.save = true

            this.model.paciente.save = true
        },
        editarItem(item) {

            this.itemEmEdicaoId = item.id
            this.isNaoPadronizado = !!item.medicamentoNaoPadronizadoId
            this.motivoId = item.motivoId || null
            this.itemAtual.medicamento = this.isNaoPadronizado ? null : this.clone(item.medicamento)
            this.itemAtual.medicamentoNaoPadronizado = this.isNaoPadronizado ? this.clone(item.medicamento) : null
            this.itemAtual.quantidade = item.quantidade
            this.itemAtual.justificativa = item.justificativa
        },
        removerItemAtual(item) {

            const receita = this.receitaAtualNaLista

            if (!receita) return

            this.showDeleteConfirmation('Deseja realmente excluir o medicamento?', async () => {

                const idx = receita.items.findIndex(i => i.id === item.id)

                if (Number.isInteger(item.id)) {

                    this.$set(receita.items[idx], 'deleted', true)

                } else {

                    receita.items.splice(idx, 1)
                }

                if (item.id === this.itemEmEdicaoId) this.resetItem()
            })
        },
        incluir(){

            const itemNaoIniciado = !this.itemAtual.medicamento
                && !this.itemAtual.medicamentoNaoPadronizado
                && !this.itemAtual.quantidade
                && !this.motivoId
                && !this.itemAtual.justificativa

            if (itemNaoIniciado && this.receitaEmEdicaoId && !this.itemEmEdicaoId) {

                this.sincronizarCabecalhoReceitaEmEdicao()
                this.resetItem()

                return
            }

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    const itemSelecionado = this.isNaoPadronizado
                        ? this.itemAtual.medicamentoNaoPadronizado
                        : this.itemAtual.medicamento

                    if (!itemSelecionado || !itemSelecionado.id) {

                        this.showValidationNotification('Selecione o item para incluir o medicamento não atendido.')

                        return
                    }

                    const medicoSolicitante = this.receitaAtual.medicoSolicitante

                    if (!medicoSolicitante || !medicoSolicitante.id) {

                        this.showValidationNotification('Selecione o médico solicitante da receita.')

                        return
                    }

                    const item = {

                        id: this.itemEmEdicaoId,
                        materialId: this.isNaoPadronizado ? null : itemSelecionado.id,
                        medicamentoNaoPadronizadoId: this.isNaoPadronizado ? itemSelecionado.id : null,
                        quantidade: this.itemAtual.quantidade,
                        justificativa: this.itemAtual.justificativa,
                        motivoId: this.motivoId,
                        motivo: (this.form.motivoMedicamentoNaoAtendido.find(m => m.id === this.motivoId) || {}).nome || null,
                        medicamento: {
                            id: itemSelecionado.id,
                            descricao: itemSelecionado.descricao || itemSelecionado.descricaoCompleta
                        },
                        save: true,
                        deleted: false,
                        confirmado: false,

                    };

                    const receita = item.id
                        ? this.model.medicamentoNaoAtendido.find(r => r.items.some(i => i.id === item.id))
                        : this.resolverReceitaAtual()

                    const incluir = () => {

                        if (item.id) {

                            const idx = receita.items.findIndex(i => i.id === item.id)
                            Object.assign(receita.items[idx], item)

                        } else {

                            item.id = `${new Date().getTime()}-medicamento-nao-atendido`
                            receita.items.push(item)
                        }

                        receita.dataReceita = this.getFormatedDate(this.receitaAtual.dataReceita, 'DD/MM/YYYY')
                        receita.medicoSolicitante = {
                            id: medicoSolicitante.id,
                            nome: medicoSolicitante.cidadaoNome
                        }
                        receita.isReceitaSus = this.receitaAtual.isReceitaSus
                        receita.save = true

                        this.receitaAtual.id = receita.id

                        this.model.paciente.save = true

                        this.resetItem()
                    }

                    const isDuplicado = receita.items.some(i =>
                        !i.deleted
                        && i.id !== item.id
                        && (this.isNaoPadronizado
                            ? i.medicamentoNaoPadronizadoId === item.medicamentoNaoPadronizadoId
                            : i.materialId === item.materialId))

                    if (isDuplicado) {

                        item.confirmado = true

                        this.showConfirmation(
                            `Já existe este medicamento incluído nesta receita. Deseja incluir mesmo assim?`,
                            async () => incluir()
                        )

                        return
                    }

                    incluir()
                })
        },
    },
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null }
    },
    mixins: [repository, object, error, data],
    watch: {
        'receitaAtual.dataReceita'() {

            this.sincronizarCabecalhoReceitaEmEdicao()
        },
        'receitaAtual.medicoSolicitante'() {

            this.sincronizarCabecalhoReceitaEmEdicao()
        },
        'receitaAtual.isReceitaSus'() {

            this.sincronizarCabecalhoReceitaEmEdicao()
        },
    },
}
</script>
